import { render, staticRenderFns } from "./typeclasssixth.vue?vue&type=template&id=6f20eb6e&scoped=true"
import script from "./typeclasssixth.vue?vue&type=script&lang=js"
export * from "./typeclasssixth.vue?vue&type=script&lang=js"
import style0 from "./typeclasssixth.vue?vue&type=style&index=0&id=6f20eb6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f20eb6e",
  null
  
)

export default component.exports